import {
	parseStyle,
	decodeStyle,
	decodeAttribute,
} from "../parser/parserResponsive";

import { mobile, tablet, isHidden, getDevice } from "../data/bp";

import { PAGE_BEFORE_ID, PAGE_AFTER_ID } from "../data/defaults";

import { getFileURL } from "../_helper/image";

import { presetToDataBlocks } from '../_helper/preset'

import { useItemsFine } from "../actions/items"

import SlateViewer from "../widgets/slateeditor/SlateViewer";

import QurealTableNewView from "../widgets/table/QurealTableNewView";

import { queryClient } from "./query"
import { atom } from "jotai";

// import { useRouter } from "next/router";

function useRouter() {
	return {};
}

const Link = ({ href, children }) => {
	return <a href={href}>{children}</a>
}


const sectionListAtom = atom([
	{
		"id": "q_tp6ba_4_34",
		"index": 0,
		"type": "dynamic",
		"preset": "document_header",
		"prefill": {
			"document_header": {
				"heading": "HeAdInG Main Heading",
				"subheading": "Here goes Letter Subtitle"
			}
		},
		"rendered": false
	},
	{
		"id": "q_0fX4pCi0jm",
		"index": 1,
		"type": "dynamic",
		"preset": "document_body",
		"prefill": {
			"document_body": {
				"content": "CoNtEnT is the content section."
			}
		},
		"rendered": false
	}
]);

export {
	parseStyle,
	decodeStyle,
	decodeAttribute,
	mobile,
	tablet,
	isHidden,
	getDevice,
	PAGE_BEFORE_ID,
	PAGE_AFTER_ID,
	getFileURL,
	SlateViewer,
	queryClient,
	QurealTableNewView,
	useItemsFine,
	presetToDataBlocks,
	sectionListAtom,
	useRouter,
	Link
};
